import { html, LitElement } from 'lit-element';
import { ScopedElementsMixin } from '@open-wc/scoped-elements';
import AabInputMessage from '@aab/sc-aab-inputmessage/src/AabInputmessage';
import Styles from './styles';

export default class AabInputblock extends ScopedElementsMixin(LitElement) {
  constructor() {
    super();
    this.inputType = 'text';
    this.inputId = '';
    this.required = false;
    this.placeholder = '';
    this.pattern = '.*';
    this.minLength = 0;
    this.maxLength = 99;
    this.label = '';
    this.value = '';
    this.message = '';
    this.messageType = 'warning';
    this.disablePaste = false;
    this.inputWidth = '';
    this.disabled = false;
  }

  static get properties() {
    return {
      inputType: { type: String, attribute: 'input-type', reflect: true },
      inputId: { type: String, attribute: 'input-id', reflect: true },
      required: { type: Boolean },
      pattern: { type: String },
      minLength: { type: Number, attribute: 'minlength', reflect: true },
      maxLength: { type: Number, attribute: 'maxlength', reflect: true },
      placeholder: { type: String },
      label: { type: String },
      value: { type: String },
      message: { type: String },
      messageType: { type: String, attribute: 'message-type', reflect: true },
      disablePaste: { type: Boolean, attribute: 'disable-paste', reflect: true },
      inputWidth: { type: String, attribute: 'input-width', reflect: true },
      disabled: { type: Boolean },
    };
  }

  static get styles() {
    return [
      Styles.commonStyles,
      Styles.labelStyles,
      Styles.inputStyles,
    ];
  }

  static get scopedElements() {
    return {
      'aab-inputmessage': AabInputMessage,
    };
  }

  render() {
    return html`
      ${this.label ? html`<label for=${this.inputId} class="input-label">${this.label}</label>` : ''}
      <input
        type=${this.inputType}
        id=${this.inputId}
        class="form-control ${this.message !== '' ? this.messageType : 'default'} ${this.inputWidth ? `width-${this.inputWidth}` : ''}"
        .value=${this.value}
        ?required=${this.required} 
        ?disabled=${this.disabled}
        pattern=${this.pattern}
        minlength=${this.minLength}
        maxlength=${this.maxLength}
        placeholder=${this.placeholder}
        @blur=${(event) => this.emitEvent(event, 'blur')}
        @input=${(event) => this.emitEvent(event, 'input')}
        @change=${(event) => this.emitEvent(event, 'change')}
        @paste=${(event) => this.handlePasteEvent(event)}
        @invalid=${(event) => this.emitEvent(event, 'invalid')}>
      ${this.message ? html`
      <div class="mt-1">
        <aab-inputmessage message=${this.message} type=${this.messageType} icon></aab-inputmessage>
      </div>
      ` : ''}
    `;
  }

  handlePasteEvent(event) {
    if (this.disablePaste) {
      // eslint-disable-next-line no-param-reassign
      event.srcElement.value = this.value;
      event.preventDefault();
    }
  }

  emitEvent(event, eventType) {
    this.dispatchEvent(
      new CustomEvent(
        `aab-inputblock-${eventType}`, {
          detail: {
            value: event.target.value,
            srcElement: event.srcElement,
          },
          bubbles: true,
          composed: true,
        },
      ),
    );
  }
}
